module.exports = __webpack_public_path__ + "static/media/empty-chat.43dbe950.svg";